/*!
 * modernizr.min.js
 */
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
 ! function(e, t, n) {
    function i(e, t) {
        return typeof e === t
    }

    function o() {
        var e, t, n, o, r, s, a;
        for (var l in w)
            if (w.hasOwnProperty(l)) {
                if (e = [], t = w[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                    for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                for (o = i(t.fn, "function") ? t.fn() : t.fn, r = 0; r < e.length; r++) s = e[r], a = s.split("."), 1 === a.length ? x[a[0]] = o : (!x[a[0]] || x[a[0]] instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])), x[a[0]][a[1]] = o), y.push((o ? "" : "no-") + a.join("-"))
            }
    }

    function r(e) {
        var t = T.className,
            n = x._config.classPrefix || "";
        if (S && (t = t.baseVal), x._config.enableJSClass) {
            var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(i, "$1" + n + "js$2")
        }
        x._config.enableClasses && (t += " " + n + e.join(" " + n), S ? T.className.baseVal = t : T.className = t)
    }

    function s() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : S ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
    }

    function a(e, t) {
        return !!~("" + e).indexOf(t)
    }

    function l(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase()
        }).replace(/^-/, "")
    }

    function c() {
        var e = t.body;
        return e || (e = s(S ? "svg" : "body"), e.fake = !0), e
    }

    function u(e, n, i, o) {
        var r, a, l, u, d = "modernizr",
            p = s("div"),
            f = c();
        if (parseInt(i, 10))
            for (; i--;) l = s("div"), l.id = o ? o[i] : d + (i + 1), p.appendChild(l);
        return r = s("style"), r.type = "text/css", r.id = "s" + d, (f.fake ? f : p).appendChild(r), f.appendChild(p), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(t.createTextNode(e)), p.id = d, f.fake && (f.style.background = "", f.style.overflow = "hidden", u = T.style.overflow, T.style.overflow = "hidden", T.appendChild(f)), a = n(p, e), f.fake ? (f.parentNode.removeChild(f), T.style.overflow = u, T.offsetHeight) : p.parentNode.removeChild(p), !!a
    }

    function d(e, t) {
        return function() {
            return e.apply(t, arguments)
        }
    }

    function p(e, t, n) {
        var o;
        for (var r in e)
            if (e[r] in t) return n === !1 ? e[r] : (o = t[e[r]], i(o, "function") ? d(o, n || t) : o);
        return !1
    }

    function f(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }

    function h(t, i) {
        var o = t.length;
        if ("CSS" in e && "supports" in e.CSS) {
            for (; o--;)
                if (e.CSS.supports(f(t[o]), i)) return !0;
            return !1
        }
        if ("CSSSupportsRule" in e) {
            for (var r = []; o--;) r.push("(" + f(t[o]) + ":" + i + ")");
            return r = r.join(" or "), u("@supports (" + r + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == getComputedStyle(e, null).position
            })
        }
        return n
    }

    function v(e, t, o, r) {
        function c() {
            d && (delete j.style, delete j.modElem)
        }
        if (r = !i(r, "undefined") && r, !i(o, "undefined")) {
            var u = h(e, o);
            if (!i(u, "undefined")) return u
        }
        for (var d, p, f, v, g, m = ["modernizr", "tspan", "samp"]; !j.style && m.length;) d = !0, j.modElem = s(m.shift()), j.style = j.modElem.style;
        for (f = e.length, p = 0; f > p; p++)
            if (v = e[p], g = j.style[v], a(v, "-") && (v = l(v)), j.style[v] !== n) {
                if (r || i(o, "undefined")) return c(), "pfx" != t || v;
                try {
                    j.style[v] = o
                } catch (e) {}
                if (j.style[v] != g) return c(), "pfx" != t || v
            }
        return c(), !1
    }

    function g(e, t, n, o, r) {
        var s = e.charAt(0).toUpperCase() + e.slice(1),
            a = (e + " " + N.join(s + " ") + s).split(" ");
        return i(t, "string") || i(t, "undefined") ? v(a, t, o, r) : (a = (e + " " + $.join(s + " ") + s).split(" "), p(a, t, n))
    }

    function m(e, t, i) {
        return g(e, n, n, t, i)
    }
    var y = [],
        w = [],
        b = {
            _version: "3.3.1",
            _config: {
                classPrefix: "",
                enableClasses: !0,
                enableJSClass: !0,
                usePrefixes: !0
            },
            _q: [],
            on: function(e, t) {
                var n = this;
                setTimeout(function() {
                    t(n[e])
                }, 0)
            },
            addTest: function(e, t, n) {
                w.push({
                    name: e,
                    fn: t,
                    options: n
                })
            },
            addAsyncTest: function(e) {
                w.push({
                    name: null,
                    fn: e
                })
            }
        },
        x = function() {};
    x.prototype = b, x = new x, x.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var k = b._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    b._prefixes = k;
    var T = t.documentElement,
        S = "svg" === T.nodeName.toLowerCase(),
        C = "Moz O ms Webkit",
        $ = b._config.usePrefixes ? C.toLowerCase().split(" ") : [];
    b._domPrefixes = $;
    var E = "CSS" in e && "supports" in e.CSS,
        A = "supportsCSS" in e;
    x.addTest("supports", E || A), x.addTest("placeholder", "placeholder" in s("input") && "placeholder" in s("textarea"));
    var N = b._config.usePrefixes ? C.split(" ") : [];
    b._cssomPrefixes = N;
    var O = b.testStyles = u;
    x.addTest("touchevents", function() {
        var n;
        if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;
        else {
            var i = ["@media (", k.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            O(i, function(e) {
                n = 9 === e.offsetTop
            })
        }
        return n
    });
    var L = {
        elem: s("modernizr")
    };
    x._q.push(function() {
        delete L.elem
    });
    var j = {
        style: L.elem.style
    };
    x._q.unshift(function() {
        delete j.style
    }), b.testProp = function(e, t, i) {
        return v([e], n, t, i)
    }, b.testAllProps = g, b.testAllProps = m, x.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && m("transform", "scale(1)", !0)
    }), x.addTest("csstransforms3d", function() {
        var e = !!m("perspective", "1px", !0),
            t = x._config.usePrefixes;
        if (e && (!t || "webkitPerspective" in T.style)) {
            var n, i = "#modernizr{width:0;height:0}";
            x.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", t && (n += ",(-webkit-transform-3d)")), n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", O(i + n, function(t) {
                e = 7 === t.offsetWidth && 18 === t.offsetHeight
            })
        }
        return e
    }), x.addTest("flexbox", m("flexBasis", "1px", !0)), o(), r(y), delete b.addTest, delete b.addAsyncTest;
    for (var D = 0; D < x._q.length; D++) x._q[D]();
    e.Modernizr = x
}(window, document),

/*!
 * Slick carousel
 */
! function(e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(function(e) {
    "use strict";
    var t = window.Slick || {};
    (t = function() {
        var t = 0;
        return function(n, i) {
            var o, r = this;
            r.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: e(n),
                appendDots: e(n),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(t, n) {
                    return e('<button type="button" />').text(n + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, r.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, e.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = e(n), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, o = e(n).data("slick") || {}, r.options = e.extend({}, r.defaults, i, o), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = e.proxy(r.autoPlay, r), r.autoPlayClear = e.proxy(r.autoPlayClear, r), r.autoPlayIterator = e.proxy(r.autoPlayIterator, r), r.changeSlide = e.proxy(r.changeSlide, r), r.clickHandler = e.proxy(r.clickHandler, r), r.selectHandler = e.proxy(r.selectHandler, r), r.setPosition = e.proxy(r.setPosition, r), r.swipeHandler = e.proxy(r.swipeHandler, r), r.dragHandler = e.proxy(r.dragHandler, r), r.keyHandler = e.proxy(r.keyHandler, r), r.instanceUid = t++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0)
        }
    }()).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, t.prototype.addSlide = t.prototype.slickAdd = function(t, n, i) {
        var o = this;
        if ("boolean" == typeof n) i = n, n = null;
        else if (n < 0 || n >= o.slideCount) return !1;
        o.unload(), "number" == typeof n ? 0 === n && 0 === o.$slides.length ? e(t).appendTo(o.$slideTrack) : i ? e(t).insertBefore(o.$slides.eq(n)) : e(t).insertAfter(o.$slides.eq(n)) : !0 === i ? e(t).prependTo(o.$slideTrack) : e(t).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(t, n) {
            e(n).attr("data-slick-index", t)
        }), o.$slidesCache = o.$slides, o.reinit()
    }, t.prototype.animateHeight = function() {
        var e = this;
        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate({
                height: t
            }, e.options.speed)
        }
    }, t.prototype.animateSlide = function(t, n) {
        var i = {},
            o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (t = -t), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: t
        }, o.options.speed, o.options.easing, n) : o.$slideTrack.animate({
            top: t
        }, o.options.speed, o.options.easing, n) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), e({
            animStart: o.currentLeft
        }).animate({
            animStart: t
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(e) {
                e = Math.ceil(e), !1 === o.options.vertical ? (i[o.animType] = "translate(" + e + "px, 0px)", o.$slideTrack.css(i)) : (i[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(i))
            },
            complete: function() {
                n && n.call()
            }
        })) : (o.applyTransition(), t = Math.ceil(t), !1 === o.options.vertical ? i[o.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[o.animType] = "translate3d(0px," + t + "px, 0px)", o.$slideTrack.css(i), n && setTimeout(function() {
            o.disableTransition(), n.call()
        }, o.options.speed))
    }, t.prototype.getNavTarget = function() {
        var t = this,
            n = t.options.asNavFor;
        return n && null !== n && (n = e(n).not(t.$slider)), n
    }, t.prototype.asNavFor = function(t) {
        var n = this.getNavTarget();
        null !== n && "object" == typeof n && n.each(function() {
            var n = e(this).slick("getSlick");
            n.unslicked || n.slideHandler(t, !0)
        })
    }, t.prototype.applyTransition = function(e) {
        var t = this,
            n = {};
        !1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
    }, t.prototype.autoPlay = function() {
        var e = this;
        e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
    }, t.prototype.autoPlayClear = function() {
        var e = this;
        e.autoPlayTimer && clearInterval(e.autoPlayTimer)
    }, t.prototype.autoPlayIterator = function() {
        var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
        e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
    }, t.prototype.buildArrows = function() {
        var t = this;
        !0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, t.prototype.buildDots = function() {
        var t, n, i = this;
        if (!0 === i.options.dots) {
            for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
            i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
        }
    }, t.prototype.buildOut = function() {
        var t = this;
        t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function(t, n) {
            e(n).attr("data-slick-index", t).data("originalStyling", e(n).attr("style") || "")
        }), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable")
    }, t.prototype.buildRows = function() {
        var e, t, n, i, o, r, s, a = this;
        if (i = document.createDocumentFragment(), r = a.$slider.children(), a.options.rows > 1) {
            for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                var l = document.createElement("div");
                for (t = 0; t < a.options.rows; t++) {
                    var c = document.createElement("div");
                    for (n = 0; n < a.options.slidesPerRow; n++) {
                        var u = e * s + (t * a.options.slidesPerRow + n);
                        r.get(u) && c.appendChild(r.get(u))
                    }
                    l.appendChild(c)
                }
                i.appendChild(l)
            }
            a.$slider.empty().append(i), a.$slider.children().children().children().css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, t.prototype.checkResponsive = function(t, n) {
        var i, o, r, s = this,
            a = !1,
            l = s.$slider.width(),
            c = window.innerWidth || e(window).width();
        if ("window" === s.respondTo ? r = c : "slider" === s.respondTo ? r = l : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
            o = null;
            for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
            null !== o ? null !== s.activeBreakpoint ? (o !== s.activeBreakpoint || n) && (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), a = o), t || !1 === a || s.$slider.trigger("breakpoint", [s, a])
        }
    }, t.prototype.changeSlide = function(t, n) {
        var i, o, r, s = this,
            a = e(t.currentTarget);
        switch (a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), r = s.slideCount % s.options.slidesToScroll != 0, i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, t.data.message) {
            case "previous":
                o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);
                break;
            case "next":
                o = 0 === i ? s.options.slidesToScroll : i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);
                break;
            case "index":
                var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
                s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
                break;
            default:
                return
        }
    }, t.prototype.checkNavigable = function(e) {
        var t, n;
        if (t = this.getNavigableIndexes(), n = 0, e > t[t.length - 1]) e = t[t.length - 1];
        else
            for (var i in t) {
                if (e < t[i]) {
                    e = n;
                    break
                }
                n = t[i]
            }
        return e
    }, t.prototype.cleanUpEvents = function() {
        var t = this;
        t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)), t.$slider.off("focus.slick blur.slick"), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow.off("keydown.slick", t.keyHandler))), t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler), t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler), t.$list.off("touchend.slick mouseup.slick", t.swipeHandler), t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler), t.$list.off("click.slick", t.clickHandler), e(document).off(t.visibilityChange, t.visibility), t.cleanUpSlideEvents(), !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler), e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange), e(window).off("resize.slick.slick-" + t.instanceUid, t.resize), e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault), e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
    }, t.prototype.cleanUpSlideEvents = function() {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1))
    }, t.prototype.cleanUpRows = function() {
        var e, t = this;
        t.options.rows > 1 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e))
    }, t.prototype.clickHandler = function(e) {
        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
    }, t.prototype.destroy = function(t) {
        var n = this;
        n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), e(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            e(this).attr("style", e(this).data("originalStyling"))
        }), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, t || n.$slider.trigger("destroy", [n])
    }, t.prototype.disableTransition = function(e) {
        var t = this,
            n = {};
        n[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
    }, t.prototype.fadeSlide = function(e, t) {
        var n = this;
        !1 === n.cssTransitions ? (n.$slides.eq(e).css({
            zIndex: n.options.zIndex
        }), n.$slides.eq(e).animate({
            opacity: 1
        }, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({
            opacity: 1,
            zIndex: n.options.zIndex
        }), t && setTimeout(function() {
            n.disableTransition(e), t.call()
        }, n.options.speed))
    }, t.prototype.fadeSlideOut = function(e) {
        var t = this;
        !1 === t.cssTransitions ? t.$slides.eq(e).animate({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }))
    }, t.prototype.filterSlides = t.prototype.slickFilter = function(e) {
        var t = this;
        null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
    }, t.prototype.focusHandler = function() {
        var t = this;
        t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(n) {
            n.stopImmediatePropagation();
            var i = e(this);
            setTimeout(function() {
                t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay())
            }, 0)
        })
    }, t.prototype.getCurrent = t.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, t.prototype.getDotCount = function() {
        var e = this,
            t = 0,
            n = 0,
            i = 0;
        if (!0 === e.options.infinite)
            if (e.slideCount <= e.options.slidesToShow) ++i;
            else
                for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else if (!0 === e.options.centerMode) i = e.slideCount;
        else if (e.options.asNavFor)
            for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
        return i - 1
    }, t.prototype.getLeft = function(e) {
        var t, n, i, o = this,
            r = 0;
        return o.slideOffset = 0, n = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, r = n * o.options.slidesToShow * -1), o.slideCount % o.options.slidesToScroll != 0 && e + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (e > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1, r = (o.options.slidesToShow - (e - o.slideCount)) * n * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, r = o.slideCount % o.options.slidesToScroll * n * -1))) : e + o.options.slidesToShow > o.slideCount && (o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth, r = (e + o.options.slidesToShow - o.slideCount) * n), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, r = 0), !0 === o.options.centerMode && o.slideCount <= o.options.slidesToShow ? o.slideOffset = o.slideWidth * Math.floor(o.options.slidesToShow) / 2 - o.slideWidth * o.slideCount / 2 : !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + r, !0 === o.options.variableWidth && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === o.options.centerMode && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (o.$list.width() - i.outerWidth()) / 2)), t
    }, t.prototype.getOption = t.prototype.slickGetOption = function(e) {
        return this.options[e]
    }, t.prototype.getNavigableIndexes = function() {
        var e, t = this,
            n = 0,
            i = 0,
            o = [];
        for (!1 === t.options.infinite ? e = t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); n < e;) o.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        return o
    }, t.prototype.getSlick = function() {
        return this
    }, t.prototype.getSlideCount = function() {
        var t, n, i = this;
        return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function(o, r) {
            if (r.offsetLeft - n + e(r).outerWidth() / 2 > -1 * i.swipeLeft) return t = r, !1
        }), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
    }, t.prototype.goTo = t.prototype.slickGoTo = function(e, t) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(e)
            }
        }, t)
    }, t.prototype.init = function(t) {
        var n = this;
        e(n.$slider).hasClass("slick-initialized") || (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), t && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay())
    }, t.prototype.initADA = function() {
        var t = this,
            n = Math.ceil(t.slideCount / t.options.slidesToShow),
            i = t.getNavigableIndexes().filter(function(e) {
                return e >= 0 && e < t.slideCount
            });
        t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(n) {
            var o = i.indexOf(n);
            e(this).attr({
                role: "tabpanel",
                id: "slick-slide" + t.instanceUid + n,
                tabindex: -1
            }), -1 !== o && e(this).attr({
                "aria-describedby": "slick-slide-control" + t.instanceUid + o
            })
        }), t.$dots.attr("role", "tablist").find("li").each(function(o) {
            var r = i[o];
            e(this).attr({
                role: "presentation"
            }), e(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + t.instanceUid + o,
                "aria-controls": "slick-slide" + t.instanceUid + r,
                "aria-label": o + 1 + " of " + n,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(t.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++) t.$slides.eq(o).attr("tabindex", 0);
        t.activateADA()
    }, t.prototype.initArrowEvents = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
    }, t.prototype.initDotEvents = function() {
        var t = this;
        !0 === t.options.dots && (e("li", t.$dots).on("click.slick", {
            message: "index"
        }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)), !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1))
    }, t.prototype.initSlideEvents = function() {
        var t = this;
        t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)))
    }, t.prototype.initializeEvents = function() {
        var t = this;
        t.initArrowEvents(), t.initDotEvents(), t.initSlideEvents(), t.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, t.swipeHandler), t.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, t.swipeHandler), t.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, t.swipeHandler), t.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, t.swipeHandler), t.$list.on("click.slick", t.clickHandler), e(document).on(t.visibilityChange, e.proxy(t.visibility, t)), !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)), e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)), e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault), e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition), e(t.setPosition)
    }, t.prototype.initUI = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
    }, t.prototype.keyHandler = function(e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "next" : "previous"
            }
        }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "previous" : "next"
            }
        }))
    }, t.prototype.lazyLoad = function() {
        function t(t) {
            e("img[data-lazy]", t).each(function() {
                var t = e(this),
                    n = e(this).attr("data-lazy"),
                    i = e(this).attr("data-srcset"),
                    o = e(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
                    s = document.createElement("img");
                s.onload = function() {
                    t.animate({
                        opacity: 0
                    }, 100, function() {
                        i && (t.attr("srcset", i), o && t.attr("sizes", o)), t.attr("src", n).animate({
                            opacity: 1
                        }, 200, function() {
                            t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), r.$slider.trigger("lazyLoaded", [r, t, n])
                    })
                }, s.onerror = function() {
                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, t, n])
                }, s.src = n
            })
        }
        var n, i, o, r = this;
        if (!0 === r.options.centerMode ? !0 === r.options.infinite ? o = (i = r.currentSlide + (r.options.slidesToShow / 2 + 1)) + r.options.slidesToShow + 2 : (i = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), o = r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide) : (i = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, o = Math.ceil(i + r.options.slidesToShow), !0 === r.options.fade && (i > 0 && i--, o <= r.slideCount && o++)), n = r.$slider.find(".slick-slide").slice(i, o), "anticipated" === r.options.lazyLoad)
            for (var s = i - 1, a = o, l = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) s < 0 && (s = r.slideCount - 1), n = (n = n.add(l.eq(s))).add(l.eq(a)), s--, a++;
        t(n), r.slideCount <= r.options.slidesToShow ? t(r.$slider.find(".slick-slide")) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? t(r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)) : 0 === r.currentSlide && t(r.$slider.find(".slick-cloned").slice(-1 * r.options.slidesToShow))
    }, t.prototype.loadSlider = function() {
        var e = this;
        e.setPosition(), e.$slideTrack.css({
            opacity: 1
        }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
    }, t.prototype.next = t.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, t.prototype.orientationChange = function() {
        var e = this;
        e.checkResponsive(), e.setPosition()
    }, t.prototype.pause = t.prototype.slickPause = function() {
        var e = this;
        e.autoPlayClear(), e.paused = !0
    }, t.prototype.play = t.prototype.slickPlay = function() {
        var e = this;
        e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
    }, t.prototype.postSlide = function(t) {
        var n = this;
        n.unslicked || (n.$slider.trigger("afterChange", [n, t]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.autoplay || e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()))
    }, t.prototype.prev = t.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, t.prototype.preventDefault = function(e) {
        e.preventDefault()
    }, t.prototype.progressiveLazyLoad = function(t) {
        t = t || 1;
        var n, i, o, r, s, a = this,
            l = e("img[data-lazy]", a.$slider);
        l.length ? (n = l.first(), i = n.attr("data-lazy"), o = n.attr("data-srcset"), r = n.attr("data-sizes") || a.$slider.attr("data-sizes"), (s = document.createElement("img")).onload = function() {
            o && (n.attr("srcset", o), r && n.attr("sizes", r)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, n, i]), a.progressiveLazyLoad()
        }, s.onerror = function() {
            t < 3 ? setTimeout(function() {
                a.progressiveLazyLoad(t + 1)
            }, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad())
        }, s.src = i) : a.$slider.trigger("allImagesLoaded", [a])
    }, t.prototype.refresh = function(t) {
        var n, i, o = this;
        i = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > i && (o.currentSlide = i), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), n = o.currentSlide, o.destroy(!0), e.extend(o, o.initials, {
            currentSlide: n
        }), o.init(), t || o.changeSlide({
            data: {
                message: "index",
                index: n
            }
        }, !1)
    }, t.prototype.registerBreakpoints = function() {
        var t, n, i, o = this,
            r = o.options.responsive || null;
        if ("array" === e.type(r) && r.length) {
            o.respondTo = o.options.respondTo || "window";
            for (t in r)
                if (i = o.breakpoints.length - 1, r.hasOwnProperty(t)) {
                    for (n = r[t].breakpoint; i >= 0;) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                    o.breakpoints.push(n), o.breakpointSettings[n] = r[t].settings
                }
            o.breakpoints.sort(function(e, t) {
                return o.options.mobileFirst ? e - t : t - e
            })
        }
    }, t.prototype.reinit = function() {
        var t = this;
        t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t])
    }, t.prototype.resize = function() {
        var t = this;
        e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function() {
            t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition()
        }, 50))
    }, t.prototype.removeSlide = t.prototype.slickRemove = function(e, t, n) {
        var i = this;
        return e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) && (i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit(), void 0)
    }, t.prototype.setCSS = function(e) {
        var t, n, i = this,
            o = {};
        !0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", o[i.positionProp] = e, !1 === i.transformsEnabled ? i.$slideTrack.css(o) : (o = {}, !1 === i.cssTransitions ? (o[i.animType] = "translate(" + t + ", " + n + ")", i.$slideTrack.css(o)) : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)", i.$slideTrack.css(o)))
    }, t.prototype.setDimensions = function() {
        var e = this;
        !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
            padding: "0px " + e.options.centerPadding
        }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
            padding: e.options.centerPadding + " 0px"
        })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
    }, t.prototype.setFade = function() {
        var t, n = this;
        n.$slides.each(function(i, o) {
            t = n.slideWidth * i * -1, !0 === n.options.rtl ? e(o).css({
                position: "relative",
                right: t,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            }) : e(o).css({
                position: "relative",
                left: t,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            })
        }), n.$slides.eq(n.currentSlide).css({
            zIndex: n.options.zIndex - 1,
            opacity: 1
        })
    }, t.prototype.setHeight = function() {
        var e = this;
        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t)
        }
    }, t.prototype.setOption = t.prototype.slickSetOption = function() {
        var t, n, i, o, r, s = this,
            a = !1;
        if ("object" === e.type(arguments[0]) ? (i = arguments[0], a = arguments[1], r = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? r = "responsive" : void 0 !== arguments[1] && (r = "single")), "single" === r) s.options[i] = o;
        else if ("multiple" === r) e.each(i, function(e, t) {
            s.options[e] = t
        });
        else if ("responsive" === r)
            for (n in o)
                if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
                else {
                    for (t = s.options.responsive.length - 1; t >= 0;) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                    s.options.responsive.push(o[n])
                }
        a && (s.unload(), s.reinit())
    }, t.prototype.setPosition = function() {
        var e = this;
        e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e])
    }, t.prototype.setProps = function() {
        var e = this,
            t = document.body.style;
        e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform",
            e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
    }, t.prototype.setSlideClasses = function(e) {
        var t, n, i, o, r = this;
        n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode ? (t = Math.floor(r.options.slidesToShow / 2), !0 === r.options.infinite && (e >= t && e <= r.slideCount - 1 - t ? r.$slides.slice(e - t, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = r.options.slidesToShow + e, n.slice(i - t + 1, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(e).addClass("slick-center")) : e >= 0 && e <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(e, e + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= r.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (o = r.slideCount % r.options.slidesToShow, i = !0 === r.options.infinite ? r.options.slidesToShow + e : e, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow ? n.slice(i - (r.options.slidesToShow - o), i + o).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" !== r.options.lazyLoad && "anticipated" !== r.options.lazyLoad || r.lazyLoad()
    }, t.prototype.setupInfinite = function() {
        var t, n, i, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (n = null, o.slideCount > o.options.slidesToShow)) {
            for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1) n = t - 1, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (t = 0; t < i + o.slideCount; t += 1) n = t, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                e(this).attr("id", "")
            })
        }
    }, t.prototype.interrupt = function(e) {
        var t = this;
        e || t.autoPlay(), t.interrupted = e
    }, t.prototype.selectHandler = function(t) {
        var n = this,
            i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
            o = parseInt(i.attr("data-slick-index"));
        o || (o = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(o, !1, !0) : n.slideHandler(o)
    }, t.prototype.slideHandler = function(e, t, n) {
        var i, o, r, s, a, l = null,
            c = this;
        if (t = t || !1, !(!0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === e))
            if (!1 === t && c.asNavFor(e), i = e, l = c.getLeft(i), s = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function() {
                c.postSlide(i)
            }) : c.postSlide(i));
            else if (!1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function() {
            c.postSlide(i)
        }) : c.postSlide(i));
        else {
            if (c.options.autoplay && clearInterval(c.autoPlayTimer), o = i < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + i : i >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : i - c.slideCount : i, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), r = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide), c.updateDots(), c.updateArrows(), !0 === c.options.fade) return !0 !== n ? (c.fadeSlideOut(r), c.fadeSlide(o, function() {
                c.postSlide(o)
            })) : c.postSlide(o), void c.animateHeight();
            !0 !== n ? c.animateSlide(l, function() {
                c.postSlide(o)
            }) : c.postSlide(o)
        }
    }, t.prototype.startLoad = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
    }, t.prototype.swipeDirection = function() {
        var e, t, n, i, o = this;
        return e = o.touchObject.startX - o.touchObject.curX, t = o.touchObject.startY - o.touchObject.curY, n = Math.atan2(t, e), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 ? !1 === o.options.rtl ? "left" : "right" : i <= 360 && i >= 315 ? !1 === o.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical"
    }, t.prototype.swipeEnd = function(e) {
        var t, n, i = this;
        if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1, !1;
        if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX) return !1;
        if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
            switch (n = i.swipeDirection()) {
                case "left":
                case "down":
                    t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
            }
            "vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
        } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
    }, t.prototype.swipeHandler = function(e) {
        var t = this;
        if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
            case "start":
                t.swipeStart(e);
                break;
            case "move":
                t.swipeMove(e);
                break;
            case "end":
                t.swipeEnd(e)
        }
    }, t.prototype.swipeMove = function(e) {
        var t, n, i, o, r, s, a = this;
        return r = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!a.dragging || a.scrolling || r && 1 !== r.length) && (t = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX, a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && s > 4 ? (a.scrolling = !0, !1) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s), n = a.swipeDirection(), void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && (a.swiping = !0, e.preventDefault()), o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1), i = a.touchObject.swipeLength, a.touchObject.edgeHit = !1, !1 === a.options.infinite && (0 === a.currentSlide && "right" === n || a.currentSlide >= a.getDotCount() && "left" === n) && (i = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = t + i * o : a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * o, !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))))
    }, t.prototype.swipeStart = function(e) {
        var t, n = this;
        return n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow ? (n.touchObject = {}, !1) : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, n.dragging = !0, void 0)
    }, t.prototype.unfilterSlides = t.prototype.slickUnfilter = function() {
        var e = this;
        null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
    }, t.prototype.unload = function() {
        var t = this;
        e(".slick-cloned", t.$slider).remove(), t.$dots && t.$dots.remove(), t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(), t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(), t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, t.prototype.unslick = function(e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]), t.destroy()
    }, t.prototype.updateArrows = function() {
        var e = this;
        Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, t.prototype.updateDots = function() {
        var e = this;
        null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
    }, t.prototype.visibility = function() {
        var e = this;
        e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
    }, e.fn.slick = function() {
        var e, n, i = this,
            o = arguments[0],
            r = Array.prototype.slice.call(arguments, 1),
            s = i.length;
        for (e = 0; e < s; e++)
            if ("object" == typeof o || void 0 === o ? i[e].slick = new t(i[e], o) : n = i[e].slick[o].apply(i[e].slick, r), void 0 !== n) return n;
        return i
    }
}),
/*!
 * Remodal
 */
/*
 *  Remodal - v1.1.1
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */
! function(e, t) {
    "function" == typeof define && define.amd ? define(["jquery"], function(n) {
        return t(e, n)
    }) : "object" == typeof exports ? t(e, require("jquery")) : t(e, e.jQuery || e.Zepto)
}(this, function(e, t) {
    "use strict";

    function n(e) {
        if (k && "none" === e.css("animation-name") && "none" === e.css("-webkit-animation-name") && "none" === e.css("-moz-animation-name") && "none" === e.css("-o-animation-name") && "none" === e.css("-ms-animation-name")) return 0;
        var t, n, i, o, r = e.css("animation-duration") || e.css("-webkit-animation-duration") || e.css("-moz-animation-duration") || e.css("-o-animation-duration") || e.css("-ms-animation-duration") || "0s",
            s = e.css("animation-delay") || e.css("-webkit-animation-delay") || e.css("-moz-animation-delay") || e.css("-o-animation-delay") || e.css("-ms-animation-delay") || "0s",
            a = e.css("animation-iteration-count") || e.css("-webkit-animation-iteration-count") || e.css("-moz-animation-iteration-count") || e.css("-o-animation-iteration-count") || e.css("-ms-animation-iteration-count") || "1";
        for (r = r.split(", "), s = s.split(", "), a = a.split(", "), o = 0, n = r.length, t = Number.NEGATIVE_INFINITY; o < n; o++) i = parseFloat(r[o]) * parseInt(a[o], 10) + parseFloat(s[o]), i > t && (t = i);
        return t
    }

    function i() {
        if (t(document).height() <= t(window).height()) return 0;
        var e, n, i = document.createElement("div"),
            o = document.createElement("div");
        return i.style.visibility = "hidden", i.style.width = "100px", document.body.appendChild(i), e = i.offsetWidth, i.style.overflow = "scroll", o.style.width = "100%", i.appendChild(o), n = o.offsetWidth, i.parentNode.removeChild(i), e - n
    }

    function o() {
        if (!T) {
            var e, n, o = t("html"),
                r = u("is-locked");
            o.hasClass(r) || (n = t(document.body), e = parseInt(n.css("padding-right"), 10) + i(), n.css("padding-right", e + "px"), o.addClass(r))
        }
    }

    function r() {
        if (!T) {
            var e, n, o = t("html"),
                r = u("is-locked");
            o.hasClass(r) && (n = t(document.body), e = parseInt(n.css("padding-right"), 10) - i(), n.css("padding-right", e + "px"), o.removeClass(r))
        }
    }

    function s(e, t, n, i) {
        var o = u("is", t),
            r = [u("is", b.CLOSING), u("is", b.OPENING), u("is", b.CLOSED), u("is", b.OPENED)].join(" ");
        e.$bg.removeClass(r).addClass(o), e.$overlay.removeClass(r).addClass(o), e.$wrapper.removeClass(r).addClass(o), e.$modal.removeClass(r).addClass(o), e.state = t, !n && e.$modal.trigger({
            type: t,
            reason: i
        }, [{
            reason: i
        }])
    }

    function a(e, i, o) {
        var r = 0,
            s = function(e) {
                e.target === this && r++
            },
            a = function(e) {
                e.target === this && 0 === --r && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
                    o[t].off(m + " " + y)
                }), i())
            };
        t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
            o[t].on(m, s).on(y, a)
        }), e(), 0 === n(o.$bg) && 0 === n(o.$overlay) && 0 === n(o.$wrapper) && 0 === n(o.$modal) && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
            o[t].off(m + " " + y)
        }), i())
    }

    function l(e) {
        e.state !== b.CLOSED && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(t, n) {
            e[n].off(m + " " + y)
        }), e.$bg.removeClass(e.settings.modifier), e.$overlay.removeClass(e.settings.modifier).hide(), e.$wrapper.hide(), r(), s(e, b.CLOSED, !0))
    }

    function c(e) {
        var t, n, i, o, r = {};
        for (e = e.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ","), t = e.split(","), o = 0, n = t.length; o < n; o++) t[o] = t[o].split(":"), i = t[o][1], ("string" == typeof i || i instanceof String) && (i = "true" === i || "false" !== i && i), ("string" == typeof i || i instanceof String) && (i = isNaN(i) ? i : +i), r[t[o][0]] = i;
        return r
    }

    function u() {
        for (var e = g, t = 0; t < arguments.length; ++t) e += "-" + arguments[t];
        return e
    }

    function d() {
        var e, n, i = location.hash.replace("#", "");
        if (i) {
            try {
                n = t('[data-remodal-id="' + i + '"]')
            } catch (e) {}
            n && n.length && (e = t[v].lookup[n.data(v)], e && e.settings.hashTracking && e.open())
        } else f && f.state === b.OPENED && f.settings.hashTracking && f.close()
    }

    function p(e, n) {
        var i = t(document.body),
            o = i,
            r = this;
        r.settings = t.extend({}, w, n), r.index = t[v].lookup.push(r) - 1, r.state = b.CLOSED, r.$overlay = t("." + u("overlay")), null !== r.settings.appendTo && r.settings.appendTo.length && (o = t(r.settings.appendTo)), r.$overlay.length || (r.$overlay = t("<div>").addClass(u("overlay") + " " + u("is", b.CLOSED)).hide(), o.append(r.$overlay)), r.$bg = t("." + u("bg")).addClass(u("is", b.CLOSED)), r.$modal = e.addClass(g + " " + u("is-initialized") + " " + r.settings.modifier + " " + u("is", b.CLOSED)).attr("tabindex", "-1"), r.$wrapper = t("<div>").addClass(u("wrapper") + " " + r.settings.modifier + " " + u("is", b.CLOSED)).hide().append(r.$modal), o.append(r.$wrapper), r.$wrapper.on("click." + g, '[data-remodal-action="close"]', function(e) {
            e.preventDefault(), r.close()
        }), r.$wrapper.on("click." + g, '[data-remodal-action="cancel"]', function(e) {
            e.preventDefault(), r.$modal.trigger(x.CANCELLATION), r.settings.closeOnCancel && r.close(x.CANCELLATION)
        }), r.$wrapper.on("click." + g, '[data-remodal-action="confirm"]', function(e) {
            e.preventDefault(), r.$modal.trigger(x.CONFIRMATION), r.settings.closeOnConfirm && r.close(x.CONFIRMATION)
        }), r.$wrapper.on("click." + g, function(e) {
            var n = t(e.target);
            n.hasClass(u("wrapper")) && r.settings.closeOnOutsideClick && r.close()
        })
    }
    var f, h, v = "remodal",
        g = e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.NAMESPACE || v,
        m = t.map(["animationstart", "webkitAnimationStart", "MSAnimationStart", "oAnimationStart"], function(e) {
            return e + "." + g
        }).join(" "),
        y = t.map(["animationend", "webkitAnimationEnd", "MSAnimationEnd", "oAnimationEnd"], function(e) {
            return e + "." + g
        }).join(" "),
        w = t.extend({
            hashTracking: !0,
            closeOnConfirm: !0,
            closeOnCancel: !0,
            closeOnEscape: !0,
            closeOnOutsideClick: !0,
            modifier: "",
            appendTo: null
        }, e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.DEFAULTS),
        b = {
            CLOSING: "closing",
            CLOSED: "closed",
            OPENING: "opening",
            OPENED: "opened"
        },
        x = {
            CONFIRMATION: "confirmation",
            CANCELLATION: "cancellation"
        },
        k = function() {
            var e = document.createElement("div").style;
            return void 0 !== e.animationName || void 0 !== e.WebkitAnimationName || void 0 !== e.MozAnimationName || void 0 !== e.msAnimationName || void 0 !== e.OAnimationName
        }(),
        T = /iPad|iPhone|iPod/.test(navigator.platform);
    p.prototype.open = function() {
        var e, n = this;
        n.state !== b.OPENING && n.state !== b.CLOSING && (e = n.$modal.attr("data-remodal-id"), e && n.settings.hashTracking && (h = t(window).scrollTop(), location.hash = e), f && f !== n && l(f), f = n, o(), n.$bg.addClass(n.settings.modifier), n.$overlay.addClass(n.settings.modifier).show(), n.$wrapper.show().scrollTop(0), n.$modal.focus(), a(function() {
            s(n, b.OPENING)
        }, function() {
            s(n, b.OPENED)
        }, n))
    }, p.prototype.close = function(e) {
        var n = this;
        n.state !== b.OPENING && n.state !== b.CLOSING && n.state !== b.CLOSED && (n.settings.hashTracking && n.$modal.attr("data-remodal-id") === location.hash.substr(1) && (location.hash = "", t(window).scrollTop(h)), a(function() {
            s(n, b.CLOSING, !1, e)
        }, function() {
            n.$bg.removeClass(n.settings.modifier), n.$overlay.removeClass(n.settings.modifier).hide(), n.$wrapper.hide(), r(), s(n, b.CLOSED, !1, e)
        }, n))
    }, p.prototype.getState = function() {
        return this.state
    }, p.prototype.destroy = function() {
        var e, n = t[v].lookup;
        l(this), this.$wrapper.remove(), delete n[this.index], e = t.grep(n, function(e) {
            return !!e
        }).length, 0 === e && (this.$overlay.remove(), this.$bg.removeClass(u("is", b.CLOSING) + " " + u("is", b.OPENING) + " " + u("is", b.CLOSED) + " " + u("is", b.OPENED)))
    }, t[v] = {
        lookup: []
    }, t.fn[v] = function(e) {
        var n, i;
        return this.each(function(o, r) {
            i = t(r), null == i.data(v) ? (n = new p(i, e), i.data(v, n.index), n.settings.hashTracking && i.attr("data-remodal-id") === location.hash.substr(1) && n.open()) : n = t[v].lookup[i.data(v)]
        }), n
    }, t(document).ready(function() {
        t(document).on("click", "[data-remodal-target]", function(e) {
            e.preventDefault();
            var n = e.currentTarget,
                i = n.getAttribute("data-remodal-target"),
                o = t('[data-remodal-id="' + i + '"]');
            t[v].lookup[o.data(v)].open()
        }), t(document).find("." + g).each(function(e, n) {
            var i = t(n),
                o = i.data("remodal-options");
            o ? ("string" == typeof o || o instanceof String) && (o = c(o)) : o = {}, i[v](o)
        }), t(document).on("keydown." + g, function(e) {
            f && f.settings.closeOnEscape && f.state === b.OPENED && 27 === e.keyCode && f.close()
        }), t(window).on("hashchange." + g, d)
    })
}),
/*!
 * Vimeo API
 */
/*! @vimeo/player v2.2.1 | (c) 2017 Vimeo | MIT License | https://github.com/vimeo/player.js */
! function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.Vimeo = e.Vimeo || {}, e.Vimeo.Player = t())
}(this, function() {
    "use strict";

    function e(e, t) {
        return 0 === e.indexOf(t.toLowerCase()) ? e : "" + t.toLowerCase() + e.substr(0, 1).toUpperCase() + e.substr(1)
    }

    function t(e) {
        return e instanceof window.HTMLElement
    }

    function n(e) {
        return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e
    }

    function i(e) {
        return /^(https?:)?\/\/((player|www).)?vimeo.com(?=$|\/)/.test(e)
    }

    function o() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.id,
            o = e.url,
            r = t || o;
        if (!r) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
        if (n(r)) return "https://vimeo.com/" + r;
        if (i(r)) return r.replace("http:", "https:");
        if (t) throw new TypeError("“" + t + "” is not a valid video id.");
        throw new TypeError("“" + r + "” is not a vimeo.com url.")
    }

    function r(e, t) {
        return t = {
            exports: {}
        }, e(t, t.exports), t.exports
    }

    function s(e, t, n) {
        var i = T.get(e.element) || {};
        t in i || (i[t] = []), i[t].push(n), T.set(e.element, i)
    }

    function a(e, t) {
        return (T.get(e.element) || {})[t] || []
    }

    function l(e, t, n) {
        var i = T.get(e.element) || {};
        if (!i[t]) return !0;
        if (!n) return i[t] = [], T.set(e.element, i), !0;
        var o = i[t].indexOf(n);
        return -1 !== o && i[t].splice(o, 1), T.set(e.element, i), i[t] && 0 === i[t].length
    }

    function c(e, t) {
        var n = a(e, t);
        if (n.length < 1) return !1;
        var i = n.shift();
        return l(e, t, i), i
    }

    function u(e, t) {
        var n = T.get(e);
        T.set(t, n), T.delete(e)
    }

    function d(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return S.reduce(function(t, n) {
            var i = e.getAttribute("data-vimeo-" + n);
            return (i || "" === i) && (t[n] = "" === i ? 1 : i), t
        }, t)
    }

    function p(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return new Promise(function(n, o) {
            if (!i(e)) throw new TypeError("“" + e + "” is not a vimeo.com url.");
            var r = "https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(e);
            for (var s in t) t.hasOwnProperty(s) && (r += "&" + s + "=" + encodeURIComponent(t[s]));
            var a = "XDomainRequest" in window ? new XDomainRequest : new XMLHttpRequest;
            a.open("GET", r, !0), a.onload = function() {
                if (404 === a.status) return void o(new Error("“" + e + "” was not found."));
                if (403 === a.status) return void o(new Error("“" + e + "” is not embeddable."));
                try {
                    var t = JSON.parse(a.responseText);
                    n(t)
                } catch (e) {
                    o(e)
                }
            }, a.onerror = function() {
                var e = a.status ? " (" + a.status + ")" : "";
                o(new Error("There was an error fetching the embed code from Vimeo" + e + "."))
            }, a.send()
        })
    }

    function f(e, t) {
        var n = e.html;
        if (!t) throw new TypeError("An element must be provided");
        if (null !== t.getAttribute("data-vimeo-initialized")) return t.querySelector("iframe");
        var i = document.createElement("div");
        return i.innerHTML = n, t.appendChild(i.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe")
    }

    function h(e) {
        return "string" == typeof e && (e = JSON.parse(e)), e
    }

    function v(e, t, n) {
        if (e.element.contentWindow && e.element.contentWindow.postMessage) {
            var i = {
                method: t
            };
            void 0 !== n && (i.value = n);
            var o = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
            o >= 8 && o < 10 && (i = JSON.stringify(i)), e.element.contentWindow.postMessage(i, e.origin)
        }
    }

    function g(e, t) {
        t = h(t);
        var n = [],
            i = void 0;
        if (t.event) "error" === t.event && a(e, t.data.method).forEach(function(n) {
            var i = new Error(t.data.message);
            i.name = t.data.name, n.reject(i), l(e, t.data.method, n)
        }), n = a(e, "event:" + t.event), i = t.data;
        else if (t.method) {
            var o = c(e, t.method);
            o && (n.push(o), i = t.value)
        }
        n.forEach(function(t) {
            try {
                if ("function" == typeof t) return void t.call(e, i);
                t.resolve(i)
            } catch (e) {}
        })
    }

    function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }
    var y = "undefined" != typeof global && "[object global]" === {}.toString.call(global),
        w = void 0 !== Array.prototype.indexOf,
        b = "undefined" != typeof window && void 0 !== window.postMessage;
    if (!(y || w && b)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
    var x = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
        k = (r(function(e, t) {
            ! function(e) {
                function t(e, t) {
                    function i(e) {
                        return this && this.constructor === i ? (this._keys = [], this._values = [], this._itp = [], this.objectOnly = t, e && n.call(this, e), void 0) : new i(e)
                    }
                    return t || w(e, "size", {
                        get: g
                    }), e.constructor = i, i.prototype = e, i
                }

                function n(e) {
                    this.add ? e.forEach(this.add, this) : e.forEach(function(e) {
                        this.set(e[0], e[1])
                    }, this)
                }

                function i(e) {
                    return this.has(e) && (this._keys.splice(y, 1), this._values.splice(y, 1), this._itp.forEach(function(e) {
                        y < e[0] && e[0]--
                    })), -1 < y
                }

                function o(e) {
                    return this.has(e) ? this._values[y] : void 0
                }

                function r(e, t) {
                    if (this.objectOnly && t !== Object(t)) throw new TypeError("Invalid value used as weak collection key");
                    if (t != t || 0 === t)
                        for (y = e.length; y-- && !b(e[y], t););
                    else y = e.indexOf(t);
                    return -1 < y
                }

                function s(e) {
                    return r.call(this, this._values, e)
                }

                function a(e) {
                    return r.call(this, this._keys, e)
                }

                function l(e, t) {
                    return this.has(e) ? this._values[y] = t : this._values[this._keys.push(e) - 1] = t, this
                }

                function c(e) {
                    return this.has(e) || this._values.push(e), this
                }

                function u() {
                    (this._keys || 0).length = this._values.length = 0
                }

                function d() {
                    return v(this._itp, this._keys)
                }

                function p() {
                    return v(this._itp, this._values)
                }

                function f() {
                    return v(this._itp, this._keys, this._values)
                }

                function h() {
                    return v(this._itp, this._values, this._values)
                }

                function v(e, t, n) {
                    var i = [0],
                        o = !1;
                    return e.push(i), {
                        next: function() {
                            var r, s = i[0];
                            return !o && s < t.length ? (r = n ? [t[s], n[s]] : t[s], i[0]++) : (o = !0, e.splice(e.indexOf(i), 1)), {
                                done: o,
                                value: r
                            }
                        }
                    }
                }

                function g() {
                    return this._values.length
                }

                function m(e, t) {
                    for (var n = this.entries();;) {
                        var i = n.next();
                        if (i.done) break;
                        e.call(t, i.value[1], i.value[0], this)
                    }
                }
                var y, w = Object.defineProperty,
                    b = function(e, t) {
                        return e === t || e !== e && t !== t
                    };
                "undefined" == typeof WeakMap && (e.WeakMap = t({
                    delete: i,
                    clear: u,
                    get: o,
                    has: a,
                    set: l
                }, !0)), "undefined" != typeof Map && "function" == typeof(new Map).values && (new Map).values().next || (e.Map = t({
                    delete: i,
                    has: a,
                    get: o,
                    set: l,
                    keys: d,
                    values: p,
                    entries: f,
                    forEach: m,
                    clear: u
                })), "undefined" != typeof Set && "function" == typeof(new Set).values && (new Set).values().next || (e.Set = t({
                    has: s,
                    add: c,
                    delete: i,
                    clear: u,
                    keys: p,
                    values: p,
                    entries: h,
                    forEach: m
                })), "undefined" == typeof WeakSet && (e.WeakSet = t({
                    delete: i,
                    add: c,
                    clear: u,
                    has: s
                }, !0))
            }(void 0 !== x ? x : window)
        }), r(function(e) {
            var t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            };
            ! function(t, n, i) {
                n[t] = n[t] || i(), e.exports && (e.exports = n[t])
            }("Promise", x, function() {
                function e(e, t) {
                    f.add(e, t), p || (p = v(f.drain))
                }

                function n(e) {
                    var n, i = void 0 === e ? "undefined" : t(e);
                    return null == e || "object" != i && "function" != i || (n = e.then), "function" == typeof n && n
                }

                function i() {
                    for (var e = 0; e < this.chain.length; e++) o(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
                    this.chain.length = 0
                }

                function o(e, t, i) {
                    var o, r;
                    try {
                        !1 === t ? i.reject(e.msg) : (o = !0 === t ? e.msg : t.call(void 0, e.msg), o === i.promise ? i.reject(TypeError("Promise-chain cycle")) : (r = n(o)) ? r.call(o, i.resolve, i.reject) : i.resolve(o))
                    } catch (e) {
                        i.reject(e)
                    }
                }

                function r(t) {
                    var o, a = this;
                    if (!a.triggered) {
                        a.triggered = !0, a.def && (a = a.def);
                        try {
                            (o = n(t)) ? e(function() {
                                var e = new l(a);
                                try {
                                    o.call(t, function() {
                                        r.apply(e, arguments)
                                    }, function() {
                                        s.apply(e, arguments)
                                    })
                                } catch (t) {
                                    s.call(e, t)
                                }
                            }): (a.msg = t, a.state = 1, a.chain.length > 0 && e(i, a))
                        } catch (e) {
                            s.call(new l(a), e)
                        }
                    }
                }

                function s(t) {
                    var n = this;
                    n.triggered || (n.triggered = !0, n.def && (n = n.def), n.msg = t, n.state = 2, n.chain.length > 0 && e(i, n))
                }

                function a(e, t, n, i) {
                    for (var o = 0; o < t.length; o++) ! function(o) {
                        e.resolve(t[o]).then(function(e) {
                            n(o, e)
                        }, i)
                    }(o)
                }

                function l(e) {
                    this.def = e, this.triggered = !1
                }

                function c(e) {
                    this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0
                }

                function u(t) {
                    if ("function" != typeof t) throw TypeError("Not a function");
                    if (0 !== this.__NPO__) throw TypeError("Not a promise");
                    this.__NPO__ = 1;
                    var n = new c(this);
                    this.then = function(t, o) {
                        var r = {
                            success: "function" != typeof t || t,
                            failure: "function" == typeof o && o
                        };
                        return r.promise = new this.constructor(function(e, t) {
                            if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
                            r.resolve = e, r.reject = t
                        }), n.chain.push(r), 0 !== n.state && e(i, n), r.promise
                    }, this.catch = function(e) {
                        return this.then(void 0, e)
                    };
                    try {
                        t.call(void 0, function(e) {
                            r.call(n, e)
                        }, function(e) {
                            s.call(n, e)
                        })
                    } catch (e) {
                        s.call(n, e)
                    }
                }
                var d, p, f, h = Object.prototype.toString,
                    v = "undefined" != typeof setImmediate ? function(e) {
                        return setImmediate(e)
                    } : setTimeout;
                try {
                    Object.defineProperty({}, "x", {}), d = function(e, t, n, i) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            writable: !0,
                            configurable: !1 !== i
                        })
                    }
                } catch (e) {
                    d = function(e, t, n) {
                        return e[t] = n, e
                    }
                }
                f = function() {
                    function e(e, t) {
                        this.fn = e, this.self = t, this.next = void 0
                    }
                    var t, n, i;
                    return {
                        add: function(o, r) {
                            i = new e(o, r), n ? n.next = i : t = i, n = i, i = void 0
                        },
                        drain: function() {
                            var e = t;
                            for (t = n = p = void 0; e;) e.fn.call(e.self), e = e.next
                        }
                    }
                }();
                var g = d({}, "constructor", u, !1);
                return u.prototype = g, d(g, "__NPO__", 0, !1), d(u, "resolve", function(e) {
                    var n = this;
                    return e && "object" == (void 0 === e ? "undefined" : t(e)) && 1 === e.__NPO__ ? e : new n(function(t, n) {
                        if ("function" != typeof t || "function" != typeof n) throw TypeError("Not a function");
                        t(e)
                    })
                }), d(u, "reject", function(e) {
                    return new this(function(t, n) {
                        if ("function" != typeof t || "function" != typeof n) throw TypeError("Not a function");
                        n(e)
                    })
                }), d(u, "all", function(e) {
                    var t = this;
                    return "[object Array]" != h.call(e) ? t.reject(TypeError("Not an array")) : 0 === e.length ? t.resolve([]) : new t(function(n, i) {
                        if ("function" != typeof n || "function" != typeof i) throw TypeError("Not a function");
                        var o = e.length,
                            r = Array(o),
                            s = 0;
                        a(t, e, function(e, t) {
                            r[e] = t, ++s === o && n(r)
                        }, i)
                    })
                }), d(u, "race", function(e) {
                    var t = this;
                    return "[object Array]" != h.call(e) ? t.reject(TypeError("Not an array")) : new t(function(n, i) {
                        if ("function" != typeof n || "function" != typeof i) throw TypeError("Not a function");
                        a(t, e, function(e, t) {
                            n(t)
                        }, i)
                    })
                }), u
            })
        })),
        T = new WeakMap,
        S = ["id", "url", "width", "maxwidth", "height", "maxheight", "portrait", "title", "byline", "color", "autoplay", "autopause", "loop", "responsive", "speed", "background", "transparent"],
        C = function() {
            function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                }
            }
            return function(t, n, i) {
                return n && e(t.prototype, n), i && e(t, i), t
            }
        }(),
        $ = new WeakMap,
        E = new WeakMap,
        A = function() {
            function n(e) {
                var r = this,
                    s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (m(this, n), window.jQuery && e instanceof jQuery && (e.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), e = e[0]), "string" == typeof e && (e = document.getElementById(e)), !t(e)) throw new TypeError("You must pass either a valid element or a valid id.");
                if ("IFRAME" !== e.nodeName) {
                    var a = e.querySelector("iframe");
                    a && (e = a)
                }
                if ("IFRAME" === e.nodeName && !i(e.getAttribute("src") || "")) throw new Error("The player element passed isn’t a Vimeo embed.");
                if ($.has(e)) return $.get(e);
                this.element = e, this.origin = "*";
                var l = new k(function(t, n) {
                    var a = function(e) {
                        if (i(e.origin) && r.element.contentWindow === e.source) {
                            "*" === r.origin && (r.origin = e.origin);
                            var n = h(e.data),
                                o = "event" in n && "ready" === n.event,
                                s = "method" in n && "ping" === n.method;
                            if (o || s) return r.element.setAttribute("data-ready", "true"), void t();
                            g(r, n)
                        }
                    };
                    if (window.addEventListener ? window.addEventListener("message", a, !1) : window.attachEvent && window.attachEvent("onmessage", a), "IFRAME" !== r.element.nodeName) {
                        var l = d(e, s);
                        p(o(l), l).then(function(t) {
                            var n = f(t, e);
                            return r.element = n, u(e, n), $.set(r.element, r), t
                        }).catch(function(e) {
                            return n(e)
                        })
                    }
                });
                return E.set(this, l), $.set(this.element, this), "IFRAME" === this.element.nodeName && v(this, "ping"), this
            }
            return C(n, [{
                key: "callMethod",
                value: function(e) {
                    var t = this,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return new k(function(i, o) {
                        return t.ready().then(function() {
                            s(t, e, {
                                resolve: i,
                                reject: o
                            }), v(t, e, n)
                        })
                    })
                }
            }, {
                key: "get",
                value: function(t) {
                    var n = this;
                    return new k(function(i, o) {
                        return t = e(t, "get"), n.ready().then(function() {
                            s(n, t, {
                                resolve: i,
                                reject: o
                            }), v(n, t)
                        })
                    })
                }
            }, {
                key: "set",
                value: function(t, n) {
                    var i = this;
                    return k.resolve(n).then(function(n) {
                        if (t = e(t, "set"), void 0 === n || null === n) throw new TypeError("There must be a value to set.");
                        return i.ready().then(function() {
                            return new k(function(e, o) {
                                s(i, t, {
                                    resolve: e,
                                    reject: o
                                }), v(i, t, n)
                            })
                        })
                    })
                }
            }, {
                key: "on",
                value: function(e, t) {
                    if (!e) throw new TypeError("You must pass an event name.");
                    if (!t) throw new TypeError("You must pass a callback function.");
                    if ("function" != typeof t) throw new TypeError("The callback must be a function.");
                    0 === a(this, "event:" + e).length && this.callMethod("addEventListener", e).catch(function() {}), s(this, "event:" + e, t)
                }
            }, {
                key: "off",
                value: function(e, t) {
                    if (!e) throw new TypeError("You must pass an event name.");
                    if (t && "function" != typeof t) throw new TypeError("The callback must be a function.");
                    l(this, "event:" + e, t) && this.callMethod("removeEventListener", e).catch(function(e) {})
                }
            }, {
                key: "loadVideo",
                value: function(e) {
                    return this.callMethod("loadVideo", e)
                }
            }, {
                key: "ready",
                value: function() {
                    var e = E.get(this);
                    return k.resolve(e)
                }
            }, {
                key: "addCuePoint",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return this.callMethod("addCuePoint", {
                        time: e,
                        data: t
                    })
                }
            }, {
                key: "removeCuePoint",
                value: function(e) {
                    return this.callMethod("removeCuePoint", e)
                }
            }, {
                key: "enableTextTrack",
                value: function(e, t) {
                    if (!e) throw new TypeError("You must pass a language.");
                    return this.callMethod("enableTextTrack", {
                        language: e,
                        kind: t
                    })
                }
            }, {
                key: "disableTextTrack",
                value: function() {
                    return this.callMethod("disableTextTrack")
                }
            }, {
                key: "pause",
                value: function() {
                    return this.callMethod("pause")
                }
            }, {
                key: "play",
                value: function() {
                    return this.callMethod("play")
                }
            }, {
                key: "unload",
                value: function() {
                    return this.callMethod("unload")
                }
            }, {
                key: "getAutopause",
                value: function() {
                    return this.get("autopause")
                }
            }, {
                key: "setAutopause",
                value: function(e) {
                    return this.set("autopause", e)
                }
            }, {
                key: "getColor",
                value: function() {
                    return this.get("color")
                }
            }, {
                key: "setColor",
                value: function(e) {
                    return this.set("color", e)
                }
            }, {
                key: "getCuePoints",
                value: function() {
                    return this.get("cuePoints")
                }
            }, {
                key: "getCurrentTime",
                value: function() {
                    return this.get("currentTime")
                }
            }, {
                key: "setCurrentTime",
                value: function(e) {
                    return this.set("currentTime", e)
                }
            }, {
                key: "getDuration",
                value: function() {
                    return this.get("duration")
                }
            }, {
                key: "getEnded",
                value: function() {
                    return this.get("ended")
                }
            }, {
                key: "getLoop",
                value: function() {
                    return this.get("loop")
                }
            }, {
                key: "setLoop",
                value: function(e) {
                    return this.set("loop", e)
                }
            }, {
                key: "getPaused",
                value: function() {
                    return this.get("paused")
                }
            }, {
                key: "getPlaybackRate",
                value: function() {
                    return this.get("playbackRate")
                }
            }, {
                key: "setPlaybackRate",
                value: function(e) {
                    return this.set("playbackRate", e)
                }
            }, {
                key: "getTextTracks",
                value: function() {
                    return this.get("textTracks")
                }
            }, {
                key: "getVideoEmbedCode",
                value: function() {
                    return this.get("videoEmbedCode")
                }
            }, {
                key: "getVideoId",
                value: function() {
                    return this.get("videoId")
                }
            }, {
                key: "getVideoTitle",
                value: function() {
                    return this.get("videoTitle")
                }
            }, {
                key: "getVideoWidth",
                value: function() {
                    return this.get("videoWidth")
                }
            }, {
                key: "getVideoHeight",
                value: function() {
                    return this.get("videoHeight")
                }
            }, {
                key: "getVideoUrl",
                value: function() {
                    return this.get("videoUrl")
                }
            }, {
                key: "getVolume",
                value: function() {
                    return this.get("volume")
                }
            }, {
                key: "setVolume",
                value: function(e) {
                    return this.set("volume", e)
                }
            }]), n
        }();
    return y || (function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document,
            t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),
            n = function(e) {
                "console" in window && console.error && console.error("There was an error creating an embed: " + e)
            };
        t.forEach(function(e) {
            try {
                if (null !== e.getAttribute("data-vimeo-defer")) return;
                var t = d(e);
                p(o(t), t).then(function(t) {
                    return f(t, e)
                }).catch(n)
            } catch (e) {
                n(e)
            }
        })
    }(), function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document,
            t = function(t) {
                if (i(t.origin) && t.data && "spacechange" === t.data.event)
                    for (var n = e.querySelectorAll("iframe"), o = 0; o < n.length; o++)
                        if (n[o].contentWindow === t.source) {
                            var r = n[o].parentElement;
                            r && -1 !== r.className.indexOf("vimeo-space") && (r.style.paddingBottom = t.data.data[0].bottom + "px");
                            break
                        }
            };
        window.addEventListener ? window.addEventListener("message", t, !1) : window.attachEvent && window.attachEvent("onmessage", t)
    }()), A
}),
/*!
 * What input
 */
/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.0.5
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
! function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("whatInput", [], t) : "object" == typeof exports ? exports.whatInput = t() : e.whatInput = t()
}(this, function() {
    return function(e) {
        function t(i) {
            if (n[i]) return n[i].exports;
            var o = n[i] = {
                exports: {},
                id: i,
                loaded: !1
            };
            return e[i].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "", t(0)
    }([function(e, t) {
        "use strict";
        e.exports = function() {
            if ("undefined" == typeof document || "undefined" == typeof window) return {
                ask: function() {
                    return "initial"
                },
                element: function() {
                    return null
                },
                ignoreKeys: function() {},
                registerOnChange: function() {},
                unRegisterOnChange: function() {}
            };
            var e = document.documentElement,
                t = null,
                n = "initial",
                i = n,
                o = null,
                r = ["input", "select", "textarea"],
                s = [],
                a = [16, 17, 18, 91, 93],
                l = {
                    keydown: "keyboard",
                    keyup: "keyboard",
                    mousedown: "mouse",
                    mousemove: "mouse",
                    MSPointerDown: "pointer",
                    MSPointerMove: "pointer",
                    pointerdown: "pointer",
                    pointermove: "pointer",
                    touchstart: "touch"
                },
                c = !1,
                u = !1,
                d = {
                    x: null,
                    y: null
                },
                p = {
                    2: "touch",
                    3: "touch",
                    4: "mouse"
                },
                f = !1;
            try {
                var h = Object.defineProperty({}, "passive", {
                    get: function() {
                        f = !0
                    }
                });
                window.addEventListener("test", null, h)
            } catch (e) {}
            var v = function() {
                    var e = !!f && {
                        passive: !0
                    };
                    window.PointerEvent ? (window.addEventListener("pointerdown", g), window.addEventListener("pointermove", y)) : window.MSPointerEvent ? (window.addEventListener("MSPointerDown", g), window.addEventListener("MSPointerMove", y)) : (window.addEventListener("mousedown", g), window.addEventListener("mousemove", y), "ontouchstart" in window && (window.addEventListener("touchstart", x, e), window.addEventListener("touchend", g))), window.addEventListener(T(), y, e), window.addEventListener("keydown", x), window.addEventListener("keyup", x), window.addEventListener("focusin", w), window.addEventListener("focusout", b)
                },
                g = function(e) {
                    if (!c) {
                        var t = e.which,
                            o = l[e.type];
                        "pointer" === o && (o = k(e));
                        var s = "keyboard" === o && t && -1 === a.indexOf(t) || "mouse" === o || "touch" === o;
                        if (n !== o && s && (n = o, m("input")), i !== o && s) {
                            var u = document.activeElement;
                            u && u.nodeName && -1 === r.indexOf(u.nodeName.toLowerCase()) && (i = o, m("intent"))
                        }
                    }
                },
                m = function(t) {
                    e.setAttribute("data-what" + t, "input" === t ? n : i), S(t)
                },
                y = function(e) {
                    if ($(e), !c && !u) {
                        var t = l[e.type];
                        "pointer" === t && (t = k(e)), i !== t && (i = t, m("intent"))
                    }
                },
                w = function(n) {
                    return n.target.nodeName ? (t = n.target.nodeName.toLowerCase(), e.setAttribute("data-whatelement", t), n.target.classList && n.target.classList.length && e.setAttribute("data-whatclasses", n.target.classList.toString().replace(" ", ",")), void 0) : void b()
                },
                b = function() {
                    t = null, e.removeAttribute("data-whatelement"), e.removeAttribute("data-whatclasses")
                },
                x = function(e) {
                    g(e), window.clearTimeout(o), c = !0, o = window.setTimeout(function() {
                        c = !1
                    }, 100)
                },
                k = function(e) {
                    return "number" == typeof e.pointerType ? p[e.pointerType] : "pen" === e.pointerType ? "touch" : e.pointerType
                },
                T = function() {
                    return "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll"
                },
                S = function(e) {
                    for (var t = 0, o = s.length; t < o; t++) s[t].type === e && s[t].fn.call(void 0, "input" === e ? n : i)
                },
                C = function(e) {
                    for (var t = 0, n = s.length; t < n; t++)
                        if (s[t].fn === e) return t
                },
                $ = function(e) {
                    d.x !== e.screenX || d.y !== e.screenY ? (u = !1, d.x = e.screenX, d.y = e.screenY) : u = !0
                };
            return "addEventListener" in window && Array.prototype.indexOf && function() {
                l[T()] = "mouse", v(), m("input"), m("intent")
            }(), {
                ask: function(e) {
                    return "intent" === e ? i : n
                },
                element: function() {
                    return t
                },
                ignoreKeys: function(e) {
                    a = e
                },
                registerOnChange: function(e, t) {
                    s.push({
                        fn: e,
                        type: t || "input"
                    })
                },
                unRegisterOnChange: function(e) {
                    var t = C(e);
                    t && s.splice(t, 1)
                }
            }
        }()
    }])
}),
function(e, t, n) {
    "use strict";
    var i = {};
    i.helpers = {
        extendObj: function() {
            for (var e = 1, t = arguments.length; e < t; e++)
                for (var n in arguments[e]) arguments[e].hasOwnProperty(n) && (arguments[e][n] && arguments[e][n].constructor && arguments[e][n].constructor === Object ? (arguments[0][n] = arguments[0][n] || {}, this.extendObj(arguments[0][n], arguments[e][n])) : arguments[0][n] = arguments[e][n]);
            return arguments[0]
        }
    }, i.countWords = function(e) {
        return e.split(/\s+/).length
    }, i.generateTrimmed = function(e, t) {
        return e.split(/\s+/).slice(0, t).join(" ") + "..."
    }, i.init = function(e) {
        var n = {
            target: "",
            numOfWords: 50,
            toggle: !0,
            moreLink: "read more...",
            lessLink: "read less"
        };
        e = i.helpers.extendObj({}, n, e);
        var o, r, s, a, l, c, u, d, p, f, h = t.querySelectorAll(e.target),
            v = h.length,
            g = [],
            m = [];
        for (a = 0; a < v; a++) o = h[a].innerHTML, r = i.generateTrimmed(o, e.numOfWords), s = i.countWords(o), g.push(o), m.push(r), e.numOfWords < s - 1 && (h[a].innerHTML = m[a], u = t.createElement("div"), u.innerHTML = '<a id="rm-more_' + a + '" class="rm-link" style="cursor:pointer;">' + e.moreLink + "</a>", h[a].parentNode.insertBefore(u, h[a].nextSibling));
        for (d = t.querySelectorAll(".rm-link"), l = 0, c = d.length; l < c; l++) d[l].onclick = function() {
            p = this.getAttribute("id"), f = p.split("_")[1], "true" !== this.getAttribute("data-clicked") ? (h[f].innerHTML = g[f], e.toggle !== !1 ? (this.innerHTML = e.lessLink, this.setAttribute("data-clicked", !0)) : this.innerHTML = "") : (h[f].innerHTML = m[f], this.innerHTML = e.moreLink, this.setAttribute("data-clicked", !1))
        }
    }, window.$readMoreJS = i
}(this, this.document),
/*!
 * Custom utilities
 */
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(e) {
        for (var t = (this.document || this.ownerDocument).querySelectorAll(e), n = t.length; --n >= 0 && t.item(n) !== this;);
        return n > -1
    }), window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(e, t) {
        t = t || window;
        for (var n = 0; n < this.length; n++) e.call(t, this[n], n, this)
    }), Element.prototype.parents || (Element.prototype.parents = function(e) {
        for (var t = this; null != t.parentNode && t.parentNode != document.documentElement;) {
            if (t.parentNode.matches(e)) return t.parentNode;
            t = t.parentNode
        }
    }), document.documentElement.dataset || Object.defineProperty(Element.prototype, "dataset", {
        get: function() {
            for (var e = Object.create(null), t = 0; t < this.attributes.length; ++t) {
                var n = this.attributes[t];
                n.specified && "data-" === n.name.substring(0, 5) && ! function(t, n) {
                    var i = n.replace(/-([a-z])/g, function(e, t) {
                        return t.toUpperCase()
                    });
                    e[i] = t.getAttribute("data-" + n), Object.defineProperty(e, i, {
                        get: function() {
                            return t.getAttribute("data-" + n)
                        },
                        set: function(e) {
                            t.setAttribute("data-" + n, e)
                        }
                    })
                }(this, n.name.substring(5))
            }
            return e
        }
    }), window.registerScrollHandler = [], window.addEventListener("scroll", function(e) {
        for (var t = 0; t < window.registerScrollHandler.length; t++) window.registerScrollHandler[t](e)
    }),
    /*!
     *Cookie JS
     */
    ! function(e) {
        var t = !1;
        if ("function" == typeof define && define.amd && (define(e), t = !0), "object" == typeof exports && (module.exports = e(), t = !0), !t) {
            var n = window.Cookies,
                i = window.Cookies = e();
            i.noConflict = function() {
                return window.Cookies = n, i
            }
        }
    }(function() {
        function e() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
                var n = arguments[e];
                for (var i in n) t[i] = n[i]
            }
            return t
        }

        function t(n) {
            function i(t, o, r) {
                var s;
                if ("undefined" != typeof document) {
                    if (arguments.length > 1) {
                        if ("number" == typeof(r = e({
                                path: "/"
                            }, i.defaults, r)).expires) {
                            var a = new Date;
                            a.setMilliseconds(a.getMilliseconds() + 864e5 * r.expires), r.expires = a
                        }
                        r.expires = r.expires ? r.expires.toUTCString() : "";
                        try {
                            s = JSON.stringify(o), /^[\{\[]/.test(s) && (o = s)
                        } catch (e) {}
                        o = n.write ? n.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                        var l = "";
                        for (var c in r) r[c] && (l += "; " + c, !0 !== r[c] && (l += "=" + r[c]));
                        return document.cookie = t + "=" + o + l
                    }
                    t || (s = {});
                    for (var u = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, p = 0; p < u.length; p++) {
                        var f = u[p].split("="),
                            h = f.slice(1).join("=");
                        this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
                        try {
                            var v = f[0].replace(d, decodeURIComponent);
                            if (h = n.read ? n.read(h, v) : n(h, v) || h.replace(d, decodeURIComponent), this.json) try {
                                h = JSON.parse(h)
                            } catch (e) {}
                            if (t === v) {
                                s = h;
                                break
                            }
                            t || (s[v] = h)
                        } catch (e) {}
                    }
                    return s
                }
            }
            return i.set = i, i.get = function(e) {
                return i.call(i, e)
            }, i.getJSON = function() {
                return i.apply({
                    json: !0
                }, [].slice.call(arguments))
            }, i.defaults = {}, i.remove = function(t, n) {
                i(t, "", e(n, {
                    expires: -1
                }))
            }, i.withConverter = t, i
        }
        return t(function() {})
    });